/**
 * HistoryTimeline
 * Displays a timeline of issue history entries
 */

import { makeStyles, tokens } from '@fluentui/react-components'
import { HistoryRegular } from '@fluentui/react-icons'
import type { IssueHistoryEntry } from '../../../../domain'
import { HistoryEntry } from './HistoryEntry'
import { PanelHeader, InlineEmptyState } from '../shared'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  entries: {
    display: 'flex',
    flexDirection: 'column',
  },
})

export interface HistoryTimelineProps {
  entries: IssueHistoryEntry[]
  title?: string
}

export function HistoryTimeline({ entries, title = 'History' }: HistoryTimelineProps) {
  const styles = useStyles()

  // Sort entries by timestamp, newest first
  const sortedEntries = [...entries].sort(
    (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
  )

  if (entries.length === 0) {
    return (
      <div className={styles.root}>
        <PanelHeader icon={<HistoryRegular />} title={title} />
        <InlineEmptyState message="No history available" />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <PanelHeader icon={<HistoryRegular />} title={title} />
      <div className={styles.entries}>
        {sortedEntries.map((entry, index) => (
          <HistoryEntry
            key={entry.id}
            entry={entry}
            showLine={index < sortedEntries.length - 1}
          />
        ))}
      </div>
    </div>
  )
}
